module.exports = __webpack_public_path__ + "static/media/beach-palm.2b63c63f.svg";